import { createFileRoute, Outlet } from "@tanstack/react-router";
import { m } from "@/lib/paraglide/messages.js";

// /contacts and /contacts/:contactId share a crumb, so a contact's page leads back to the list.
export const Route = createFileRoute("/_authenticated/contacts")({
  staticData: { crumb: m.contacts_nav },
  component: Outlet,
});
